import clsx from "clsx";

import { SVG_PATHS } from "@/shared/constants/assets-path";

interface ErrorProps {
  children: React.ReactNode;
  className?: string;
  type?: "page" | "element";
  title?: string;
}

export default function Error({
  children,
  className,
  type = "element",
  title = "서비스 오류",
}: ErrorProps) {
  return (
    <section
      className={clsx(
        className,
        "flex flex-col items-center justify-center gap-3 text-center",
        { "py-14": type === "element" }
      )}
      style={type === "page" ? { height: "calc(100vh - 112px)" } : undefined}
    >
      <div className="flex h-11 w-11 items-center justify-center rounded-full bg-secondary-light03">
        <img src={SVG_PATHS.ALERT} alt="경고 아이콘" width={31} height={31} />
      </div>
      <div className="flex flex-col gap-1.5">
        <h2 className="text-base font-semibold text-primary-dark02">{title}</h2>
        <p className="text-sm tracking-tight text-primary-dark01">{children}</p>
      </div>
    </section>
  );
}
